<mat-form-field>
    <mat-label>Filtrar</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium">
  </mat-form-field>
  
  <div class="container-btn-new">
      <button mat-stroked-button (click)="newCurso()">
        <mat-icon>note_add</mat-icon>&nbsp; Nueva Entrada
      </button>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
  
    <!-- Position Column -->
    <ng-container matColumnDef="titulo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
      <td mat-cell *matCellDef="let element"> {{element.titulo}} </td>
    </ng-container>
  
    <!-- Name Column -->
    <ng-container matColumnDef="content" >
      <th mat-header-cell *matHeaderCellDef> COntenido </th>
      <td mat-cell *matCellDef="let element"> {{element.content | contenido}} </td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef> tags </th>
      <td mat-cell *matCellDef="let element"> {{element.tags}} </td>
    </ng-container>

    <!-- columna de botones Column -->
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> tags </th>
        <td mat-cell *matCellDef="let element">
            <button mat-stroked-button color="accent" (click)="editar(element)">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-stroked-button color="warn" (click)="eliminar(element)">
                <mat-icon>delete</mat-icon>
            </button>
        </td>
      </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>